import React from "react";
import {MainCP}  from "../../Components/IPC-vs-AP/MainCP"

const ViewIPCVSAP: React.FC = () => <MainCP/>

export default ViewIPCVSAP;